import React, { Component } from 'react';
import './clienti.css';
import UtentiService from '../services/Api/Utenti/UtentiApi.js';
import BootBox from 'react-bootbox';
import AccessiService from '../services/Api/Accessi/AccessiApi.js';
import link from './InserisciUtente/linkage.js';
import AccessiTable from './AccessiTable';
import UtentTable from './UtentiTable';
import RicercaUte from './RicercaUte';
import FilterDati from './FilterDati';

import Dialog from 'react-bootstrap-dialog';

export default class clientiComponent extends Component {
  state = {
    clienti: [
      // {
      //   codfid: '67301894',
      //   nome: 'Nicola La Rocca',
      //   indirizzo: 'Via dei Mille, 52',
      //   comune: 'Alghero',
      //   bollini: '1580',
      //   data: '02/01/2020',
      // },
      // {
      //   codfid: '67100671',
      //   nome: 'Adelina Bianchi',
      //   indirizzo: 'P.zza Garibaldi, 3',
      //   comune: 'Sassari',
      //   bollini: '240',
      //   data: '06/01/2020',
      // },
      // {
      //   codfid: '67100421',
      //   nome: 'Massimo Frigerio',
      //   indirizzo: 'Via XX Settembre, 8',
      //   comune: 'Fertialia',
      //   bollini: '380',
      //   data: '09/12/2019',
      // },
      // {
      //   codfid: '67100426',
      //   nome: 'Giavanna Falchi',
      //   indirizzo: 'Via Cavour, 11',
      //   comune: 'Alghero',
      //   bollini: '2140',
      //   data: '15/01/2020',
      // },
    ],
    ragsoc: '',
    dati: {
      nome: '',
      cognome: '',
    },
    nome: '',
    ErrWebApi: false,
    ErrMsg: '',
    numcli: 0,
    okMsg: null,
    show: false,
    msgrecord: '',
    okMsg1: null,
    clie: [],
    accessi: [],
    title: '',
    body: '',
  };

  componentDidMount() {
    debugger;
    this.CercaAll();
  }
  onFocusCerca = () => {
    if (this.state.ErrWebApi) {
      this.setState({
        ErrMsg: ' ',
        ErrWebApi: false,
        okMsg: false,
      });
    } else {
      this.setState({
        okMsg: null,
      });
    }
  };

  MsgBo = () => {
    this.setState.show = true;

    return (
      <BootBox
        title='Destroy planet?'
        message='Vuoi cancellare il record selezionato?' //+{this.state.msgrecord}
        show={this.state.show}
        onYesClick={this.showAlert}
        onNoClick={this.handleClose}
        onClose={this.handleClose}
      />
    );
  };

  CercaAll = () => {
    UtentiService.getAllUtentiData()
      .then((response) => this.handleResponse(response))
      .catch((error) => this.handleError(error));
  };
  _handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      this.Cerca();
    }
  };
  Cerca = () => {
    console.log('Ricerca : ', this.state.nome);

    if (this.state.nome === '') {
      this.CercaAll();
    } else {
      //const datar = { codice: this.state.nome };
      UtentiService.getUtenteCodice(this.state.nome)
        .then((response) => this.handleResponse(response))
        .catch((error) => this.handleError(error));
    }
  };

  Elimina = (k) => {
    console.log(
      'OUTPUT: clientiComponent -> Elimina -> this.state.clienti[k].id',
      this.state.clienti[k].id
    );

    this.dialog.show({
      title: 'Conferma Elimina Record',
      body:
        'Confermi la Cancellazione del record ' + this.state.clienti[k].nome,
      actions: [
        Dialog.CancelAction(this.CancelAction),
        Dialog.OKAction(() => this.OKAction(k)),
      ],
      bsSize: 'small',
      onHide: (dialog) => {
        //dialog.hide();
        console.log('closed by clicking background.');
      },
    });
  };

  modifica = (id, k) => {
    console.log('OUTPUT: clientiComponent -> modifica -> modifica', id, k);
    link.setValue(this.state.clienti[k]);
    //const newClienti = [...this.state.clienti];
    console.log(this.state.clienti[k]);
    this.setState({ clie: this.state.clienti[k] });
    this.setState({
      setDisplay: this.setDisplay,
      id: 1000,
    });

    this.props.history.push(`/insutente/${id}`);

    // this.props.history.push(
    //   `/insutente/${JSON.stringify(this.state.clienti[k])}`
    // );
  };
  setDisplay = () => {
    console.log('ciao');
  };
  handleResponseAccessi = (response) => {
    if (response.data.ok === 'OK') {
      this.setState({
        accessi: [],
        ErrWebApi: false,
        ErrMsg: '',
        okMsg: null,
        // numcli: this.state.clienti.length,
      }); //pulisco array

      this.setState({
        accessi: response.data.res,
      });
      // this.setState({
      //   numcli: this.state.clienti.length,
      // });
    } else {
      this.setState((state, props) => ({
        dati: {
          nome: response.data.ragsoc,
          cognome: '',
        },
      }));
    }
  };

  handleResponse = (response) => {
    console.log(response);

    if (response.data.ok === 'OK') {
      this.setState({
        clienti: [],
        ErrWebApi: false,
        ErrMsg: '',
        okMsg: null,
        // numcli: this.state.clienti.length,
      }); //pulisco array

      this.setState({
        clienti: response.data.res,
      });
      this.setState({
        numcli: this.state.clienti.length,
      });
    } else {
      this.setState((state, props) => ({
        dati: {
          nome: response.data.ragsoc,
          cognome: '',
        },
      }));
    }
  };
  handleError = (error, id) => {
    console.log('OUTPUT: clientiComponent -> handleError -> error', error);
    let msgremo;
    if (error.data === undefined) {
      msgremo = error;
    } else {
      msgremo = error.response.data.ragsoc;
    }

    this.setState({
      ErrMsg: this.state.nome + ' ' + msgremo,
      ErrWebApi: true,
    });
    if (id === 'accessi') {
      this.setState({
        accessi: [],
      });
    }
  };

  showAlert = () => {
    alert('Yes is clicked');
    this.setState({ show: false });
  };

  handleClose = () => {
    this.setState({ show: false });
  };
  Inserisci = (e) => {
    console.log('inserisci');
    this.props.history.push(`/insute/-1`);
    // this.props.history.push(`/insutente/-1`);
  };
  ExtHandleError = (error) => {
    console.log('verifica : ', error);
    this.setState({ okMsg: 'Record non  Cancellato :' + error });
  };

  CancelAction = (x) => {
    console.log('CancelAction ', x);
  };
  OKAction = (k) => {
    console.log('OKAction was clicked! : ', k);
    UtentiService.deleteUtenteByCode(this.state.clienti[k].id)
      .then((response) => {
        console.log(response);
        const newClienti = [...this.state.clienti]; //cero una copia
        newClienti.splice(k, 1);
        this.setState({
          clienti: newClienti,
          numcli: newClienti.length,
          okMsg: 'Record Cancellato',
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ okMsg: 'Record non  Cancellato :' + error });
      });
  };

  render() {
    return (
      <section className='container-fluid mt-0 py-3'>
        <div className='table-responsive table-wrapper'>
          <FilterDati Inserisci={this.Inserisci} numcli={this.state.numcli} />
          <div className='table-filter'>
            <Dialog
              ref={(el) => {
                this.dialog = el;
              }}
            />
            <RicercaUte
              GestMod={this.GestMod}
              nome={this.state.nome}
              _handleKeyDown={this._handleKeyDown}
              onFocusCerca={this.onFocusCerca}
              Cerca={this.Cerca}
            />
            {/* </div> */}
            {this.state.okMsg && (
              <div className='alert alert-success'>{this.state.okMsg}</div>
            )}
            {/* {this.state.okMsg1 && <MsgBoxConfirm.showMsg />} */}
            {/* {this.state.okMsg1 && <this.MsgBo />} */}
            {/* {this.state.okMsg1 && <this.MsgBo />} */}
            {/* <MsgBoxConfirm /> */}

            <UtentTable
              clienti={this.state.clienti}
              VisRecord={this.VisRecord}
              Elimina={this.Elimina}
              modifica={this.modifica}
              ExtHandleError={this.ExtHandleError}
            />
            <ErrWebApiMsg
              ErrWebApi={this.state.ErrWebApi}
              ErrMsg={this.state.ErrMsg}
            />
          </div>
          {this.state.ragsoc && (
            <div>Ragione Sociale :{this.state.ragsoc} </div>
          )}
          <div>
            Altri Dati : {this.state.dati.nome + ' ' + this.state.dati.cognome}
          </div>
          <hr></hr>
          {/*  */}

          <div className='table-title'>
            <div className='row'>
              <div className='col-sm-12'>
                <h2>Elenco Apertura Chiusura</h2>
              </div>
            </div>
          </div>
          {/*  */}
          {/* <TableSlave accessi={this.state.accessi} /> */}
          <AccessiTable accessi={this.state.accessi} />
        </div>
        {/*  */}
      </section>
    );
  }

  VisRecord = (k) => {
    console.log('**************** ', this.state.clienti[k].nome);
    this.setState((state, props) => ({ ragsoc: this.state.clienti[k].nome }));
    this.setState((state, props) => ({
      dati: {
        nome: this.state.clienti[k].codfid,
        cognome: this.state.clienti[k].comune,
      },
    }));
    AccessiService.getAccessiCodice(this.state.clienti[k].id)
      .then((response) => this.handleResponseAccessi(response))
      .catch((error) => this.handleError(error, 'accessi'));
  };
  GestMod = (event) => {
    console.log(event.target.value);
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
}

/***********************************************************************************
 *
 * @param {*} props
 *
 * non usati usati x test
 ***********************************************************************************/

/*portata fuori else inserire nei tag TableSlave*/
// function TableSlave(props) {
//   return (
//     <div className='row'>
//       {/* className='table table-striped table-bordered table-hover' */}
//       <div className='col-lg-12  mx-auto   rounded shadow  '>
//         <div className='table-responsive table-hover table-striped'>
//           <table className='table table-fixed table-hover table-striped'>
//             <thead className='table table-striped table-bordered table-hover'>
//               <tr>
//                 <th scope='col' className='col-1'>
//                   Id
//                 </th>
//                 <th scope='col' className='col-1'>
//                   IdAccessi
//                 </th>
//                 <th scope='col' className='col-4'>
//                   Descrizione
//                 </th>
//                 <th scope='col' className='col-1'>
//                   Open
//                 </th>
//                 <th scope='col' className='col-1'>
//                   Close
//                 </th>
//                 <th scope='col' className='col-4'>
//                   Data{' '}
//                 </th>
//                 {/* <th scope='col' className='col-1'>
//                   zz
//                 </th>

//                 <th scope='col' className='col-1'></th>
//                 <th scope='col' className='col-1'></th> */}
//               </tr>
//             </thead>
//             <tbody>
//               {props.accessi.map((accessi, k) => (
//                 <tr key={k}>
//                   <td className='col-1'>{k}</td>
//                   <td className='col-1'>{accessi.id}</td>
//                   <td className='col-4'>{accessi.descrizione}</td>
//                   <td className='col-1'>{accessi.opend}</td>
//                   <td className='col-1'>{accessi.closed}</td>

//                   <td className='col-4'>{accessi.datar}</td>

//                   {/* <td className='col-1'>{'ll'}</td> */}
//                   {/* <td className='col-1'>
//                     <button
//                       className='btn btn-warning table-buttons'
//                       // onClick={() => this.modifica(cliente.id, k)}
//                     >
//                       <i className='fa fa-edit' aria-hidden='true'></i> Modifica
//                     </button>
//                   </td>
//                   <td className='col-1'>
//                     <button
//                       className='btn btn-warning table-buttons'
//                       //onClick={() => this.Elimina(k)}
//                       //onClick={() => this.Elimina(k)}

//                       //per passare un parametro bisogna creare una arrowfunc
//                       //cosi non viene eseguita in fase di render
//                     >
//                       <i className='fa fa-minus' aria-hidden='true'></i> Elimina
//                     </button>
//                   </td> */}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// }
// /*per prova inserire nei tag TableSlave1*/

// function TableSlave1(props) {
//   return (
//     <div className='row'>
//       <div className='col-sm-12 react-btable'>
//         <table
//           id='clienti'
//           className='table table-striped table-bordered table-hover'
//         >
//           <thead>
//             <tr>
//               <th>Id</th>
//               <th>IdAccessi</th>
//               <th>Descrizione</th>
//               <th>Open</th>
//               <th>Close</th>
//               <th>Data </th>
//               <th>zz</th>

//               <th></th>
//               <th></th>
//               <th></th>
//             </tr>
//           </thead>
//           <tbody>
//             {props.accessi.map((accessi, k) => (
//               <tr key={k}>
//                 <td>{k}</td>
//                 <td>{accessi.id}</td>
//                 <td>{accessi.opend}</td>
//                 <td>{accessi.closed}</td>
//                 <td>{accessi.descrizione}</td>

//                 <td>{accessi.datar}</td>

//                 <td>{'ll'}</td>
//                 <td>
//                   <button
//                     className='btn btn-warning table-buttons'
//                     // onClick={() => this.modifica(cliente.id, k)}
//                   >
//                     <i className='fa fa-edit' aria-hidden='true'></i> Modifica
//                   </button>
//                 </td>
//                 <td>
//                   <button
//                     className='btn btn-warning table-buttons'
//                     //onClick={() => this.Elimina(k)}
//                     //onClick={() => this.Elimina(k)}

//                     //per passare un parametro bisogna creare una arrowfunc
//                     //cosi non viene eseguita in fase di render
//                   >
//                     <i className='fa fa-minus' aria-hidden='true'></i> Elimina
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }
function ErrWebApiMsg(props) {
  if (props.ErrWebApi) {
    return (
      <div className='alert alert-danger' role='alert'>
        <h3>{props.ErrMsg}</h3>
      </div>
    );
  }
  return null;
}
